import { pxToRem } from '../../../../utils';
import { getColorScheme } from '../../colors';
var carouselNavigationStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    var iconOnly = p.iconOnly,
        primary = p.primary,
        vertical = p.vertical;
    var colors = getColorScheme(v.colorScheme, null, primary);
    return Object.assign({
      display: 'flex',
      minHeight: pxToRem(24),
      margin: 0,
      padding: 0,
      color: v.color,
      backgroundColor: v.backgroundColor || 'inherit',
      listStyleType: 'none',
      justifyContent: 'center'
    }, iconOnly && {
      alignItems: 'center'
    }, {}, vertical && Object.assign({
      flexDirection: 'column',
      backgroundColor: v.verticalBackgroundColor,
      width: 'fit-content',
      padding: "".concat(pxToRem(8), " 0")
    }, iconOnly && {
      display: 'inline-block',
      width: 'auto'
    }), {}, !iconOnly && !vertical && {
      // primary has hardcoded grey border color
      border: "".concat(v.borderWidth, " solid ").concat(primary ? v.primaryBorderColor : v.borderColor || colors.border),
      borderRadius: pxToRem(4)
    });
  }
};
export default carouselNavigationStyles;